export const gaID = 'UA-139646200-1';
